import { apiFetch } from "./client";

function buildRequestError(payload, fallbackMessage) {
  const error = new Error(payload?.error || fallbackMessage);
  error.payload = payload;
  return error;
}

export async function fetchAdminUsers({
  search = "",
  status = "",
  role = "",
  page = 1,
  pageSize = 25,
  sort = "lastSeenAt",
  direction = "desc"
} = {}) {
  const params = new URLSearchParams();

  if (search.trim()) {
    params.set("search", search.trim());
  }

  if (status.trim()) {
    params.set("status", status.trim());
  }

  if (role.trim()) {
    params.set("role", role.trim());
  }

  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  params.set("sort", sort);
  params.set("direction", direction);

  const response = await apiFetch(`/api/admin/users?${params.toString()}`);
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw buildRequestError(payload, "Could not load admin users.");
  }

  return payload;
}

export async function fetchAdminUser(userId) {
  const response = await apiFetch(`/api/admin/users/${userId}`);
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw buildRequestError(payload, "Could not load admin user.");
  }

  return payload;
}

export async function updateAdminUserStatus(userId, { status, suspensionReason = "" }) {
  const response = await apiFetch(`/api/admin/users/${userId}/status`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ status, suspensionReason })
  });
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw buildRequestError(payload, "Could not update user status.");
  }

  return payload;
}

export async function updateAdminUserRole(userId, role) {
  const response = await apiFetch(`/api/admin/users/${userId}/role`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ role })
  });
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw buildRequestError(payload, "Could not update user role.");
  }

  return payload;
}

export async function updateAdminUserCollectorTier(userId, collectorTier) {
  const response = await apiFetch(`/api/admin/users/${userId}/collector-tier`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ collectorTier })
  });
  const payload = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw buildRequestError(payload, "Could not update user collector tier.");
  }

  return payload;
}